module.exports = __webpack_public_path__ + "media/2496003_Starhorizon_192.2b265c24.mp3";